import { hydrateRoot } from 'react-dom/client';

import type { StorefrontData } from '@frontend/storefront/data';
import { Storefront } from '@frontend/storefront/Storefront';
import '@frontend/storefront/storefront.css';

const data: StorefrontData = JSON.parse(
  document.getElementById('storefront-data')!.textContent!,
);
hydrateRoot(document.getElementById('shop')!, <Storefront data={data} />);
